<div class="video-selector-container">
  <div class="header">
    <h3>Seleccionar Vídeos para Análisis</h3>
    <div class="actions">
      <button mat-button color="primary" (click)="selectAll()">Seleccionar Todos (Página)</button>
      <button mat-button color="warn" (click)="clearSelection()" [disabled]="selectedIds.length === 0">Limpiar Sel.</button>
      <button mat-raised-button color="accent" 
              [disabled]="selectedIds.length === 0 || isLoading" 
              (click)="analyzeClicked.emit()">
        Analizar {{ selectedIds.length }} vídeos
      </button>
    </div>
  </div>

  <div class="content">
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading && teamVideos">
      <div class="video-list">
        <div class="video-item" *ngFor="let video of teamVideos.data" (click)="toggleSelection(video.video_id)">
          <mat-checkbox 
            [checked]="isSelected(video.video_id)" 
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(video.video_id)">
          </mat-checkbox>
          <div class="info">
            <h4>{{ video.video_title }}</h4>
            <span class="meta">{{ video.video_date | date:'dd/MM/yyyy' }} | Rival: {{ video.opponent_team_name || 'Desconocido' }}</span>
            <span class="meta">| {{ video.total_scenes }} escenas analizables</span>
          </div>
        </div>
      </div>

      <div class="paginator-container">
        <mat-paginator
          *ngIf="teamVideos.total_results > 0"
          [length]="teamVideos.total_results"
          [pageSize]="teamVideos.page_size"
          [pageIndex]="teamVideos.page - 1"
          (page)="onPageChange($event)"
          [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </ng-container>

    <div *ngIf="!isLoading && (!teamVideos || teamVideos.data.length === 0)" class="no-data">
      <mat-icon>videocam_off</mat-icon>
      <p>No se encontraron vídeos analizados para este equipo en la temporada seleccionada.</p>
    </div>
  </div>
</div>
